import { FC, memo } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { WithStyle } from "../../utils/WithStyle";
import { Text } from "../Text/Text.component";
import { StyledButton } from "./Button.styled";
import { ButtonProps } from "./types";

const Component: FC<ButtonProps> = memo(
    ({
        type = "button",
        children = "",
        size = "small",
        icon,
        fullWidth = false,
        variant = "filled",
        textColor,
        textVariant = "button1",
        isLoading,
        ...restProps
    }) => {
        return (
            <StyledButton
                {...{
                    type,
                    textVariant,
                    size,
                    variant,
                    fullWidth,
                    isLoading,
                    ...restProps,
                }}
            >
                {icon && typeof icon === "string" ? (
                    <img src={icon} alt="button icon" />
                ) : (
                    !isLoading && icon
                )}
                <Text variant={textVariant} color={textColor}>
                    {children}
                </Text>
                {isLoading && <BiLoaderAlt id="loading" />}
            </StyledButton>
        );
    }
);

export const Button: FC<ButtonProps> & WithStyle = Object.assign(Component, {
    Style: StyledButton,
});
